import { render, staticRenderFns } from "./SummaryPortfolioPerformanceTable.vue?vue&type=template&id=2c23a758&"
import script from "./SummaryPortfolioPerformanceTable.vue?vue&type=script&lang=js&"
export * from "./SummaryPortfolioPerformanceTable.vue?vue&type=script&lang=js&"
import style0 from "./SummaryPortfolioPerformanceTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VChip,VChipGroup,VDataTable})
